import React from 'react';
import { 
  Card, 
  CardBody, 
  CardHeader, 
  CardTitle 
} from '@patternfly/react-core';
import { ChartDonut } from '@patternfly/react-charts/victory';

export const PastWeekPerformanceCard: React.FC = () => {
  // Dummy Data
  const pastWeekCount = 12;
  const npsScore = 68; 

  // Determine Gauge Color based on your rules
  let npsColor = 'var(--pf-t--global--icon--color--status--danger--default, #c9190b)'; // Red (< 0)
  if (npsScore >= 50) {
    npsColor = 'var(--pf-t--global--icon--color--status--success--default, #3f9c35)'; // Green (>= 50)
  } else if (npsScore >= 0) {
    npsColor = 'var(--pf-t--global--icon--color--status--warning--default, #f0ab00)'; // Yellow (0 to 49)
  }

  const fillValue = npsScore + 100;
  const emptyValue = 100 - npsScore;
  const npsString = npsScore > 0 ? `+${npsScore}` : `${npsScore}`;

  return (
    <Card isCompact>
      <CardHeader>
        <CardTitle>
          Past week performance &nbsp;
          <span style={{ fontSize: 'var(--pf-t--global--font--size--sm, 12px)', color: 'var(--pf-t--global--text--color--subtle, #6a6e73)' }}>(dummy data)</span>
        </CardTitle>
      </CardHeader>
      
      <CardBody>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', paddingTop: '8px' }}>
          
          {/* Top Row: Number and Text on the same line */}
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
            <span 
              style={{ 
                fontSize: 'var(--pf-t--global--font--size--5xl, 48px)', // Increased from 36px
                fontWeight: 'bold', 
                lineHeight: 1,
                color: 'var(--pf-t--global--text--color--regular, #151515)'
              }}
            >
              {pastWeekCount}
            </span>
            <span 
              style={{ 
                fontSize: 'var(--pf-t--global--font--size--xl, 20px)', // Increased from 14px
                color: 'var(--pf-t--global--text--color--subtle, #6a6e73)',
                fontWeight: '300' // Lighter weight for contrast against the bold number
              }}
            >
              classes delivered
            </span>
          </div>

          {/* Bottom Row: Centered NPS Gauge */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {/* Wrapper slightly enlarged to match the new bolder text proportions */}
            <div style={{ height: '140px', width: '230px', overflow: 'hidden' }}>
              <ChartDonut
                ariaTitle="NPS Gauge"
                constrainToVisibleArea
                data={[
                  { x: 'Score', y: fillValue },
                  { x: 'Remaining', y: emptyValue }
                ]}
                labels={({ datum }) => datum.x === 'Score' ? `NPS: ${npsString}` : null}
                colorScale={[npsColor, 'var(--pf-t--global--border--color--default, #d2d2d2)']}
                startAngle={-90}
                endAngle={90}
                title={npsString}
                subTitle="Average NPS"
                padding={{ bottom: 0, left: 10, right: 10, top: 10 }}
              />
            </div>
          </div>

        </div>
      </CardBody>
    </Card>
  );
};